import type { _Lesson } from "@voomp/play-back";

export function getLessonIcon(mediaType: string, options: {
  status?: string,
  lock?: boolean
} = {}) {
  if (options.status === 'draft') {
    return 'warning';
  }
  if (options.lock) {
    return 'lock'
  }
  return {
    'video': 'play_circle',
    'voomptube': 'play_circle',
    'iframe': 'play_circle',
    'panda': 'play_circle',
    'youtube': 'play_circle',
    'vimeo': 'play_circle',
    'audio': 'mic',
    'text': 'description',
    'quiz': 'assignment_turned_in',
    'exercise': 'assignment_turned_in',
  }[mediaType];
}
